var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSbProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.4 6.95L9.4 0.2C9.75556 -0.0666667 10.2444 -0.0666667 10.6 0.2L19.6 6.95C19.8518 7.13885 20 7.43524 20 7.75V22.25H14.6429C14.7376 22.25 14.8284 22.2149 14.8954 22.1524C14.9624 22.0899 15 22.0051 15 21.9167C14.9985 20.6794 14.4712 19.4933 13.5339 18.6184C12.5965 17.7435 11.3256 17.2514 10 17.25C8.67438 17.2514 7.40349 17.7435 6.46614 18.6184C5.52878 19.4933 5.00151 20.6794 5 21.9167C5 22.0051 5.03763 22.0899 5.1046 22.1524C5.17158 22.2149 5.26242 22.25 5.35714 22.25H0V7.75C0 7.43524 0.148194 7.13885 0.4 6.95ZM12.5 13.5C12.5 14.8807 11.3807 16 10 16C8.61929 16 7.5 14.8807 7.5 13.5C7.5 12.1193 8.61929 11 10 11C11.3807 11 12.5 12.1193 12.5 13.5Z",
    fill: "#ECECEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSbProfileIcon);
export default __webpack_public_path__ + "static/media/SBProfileIcon.66d338b11eeea87b7aabd960d7fc4990.svg";
export { ForwardRef as ReactComponent };